import Vue from 'vue';

export default Vue.component('social-media-item', {
  template: require('./template.html'),
  name: 'social-media-item',
  props: [
    'cls',
    'link',
  ],
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/social-media/components/social-media-item/index.js